import {
  credentialsSignIn,
  signUp,
  confirmSignUp,
  resendConfirmationCode,
  forgotPassword,
  confirmForgotPassword,
  refreshToken,
  signOut,
  deleteAccount,
  getSocialAuthUrl,
  federatedSignIn,
  federatedSignUp,
  linkFederatedIdentity,
  authCodeSignIn,
  disableAccount,
  changePassword
} from './api'

export const useAuth = () => ({
  credentialsSignIn,
  authCodeSignIn,
  signUp,
  confirmSignUp,
  resendConfirmationCode,
  forgotPassword,
  confirmForgotPassword,
  refreshToken,
  signOut,
  deleteAccount,
  getSocialAuthUrl,
  federatedSignIn,
  federatedSignUp,
  linkFederatedIdentity,
  disableAccount,
  changePassword
})
